import {Dispatch, FC, SetStateAction, useCallback, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {Controller, useForm} from 'react-hook-form'
import {KTSVG} from '../../../../../../../../_metronic/helpers'

import {yupResolver} from '@hookform/resolvers/yup'
import Swal from 'sweetalert2'
import * as Yup from 'yup'
import {SearchHuespedModel} from '../../../../models/ckecking.model'
import {searchGuestService} from '../../../../services/checking.service'
import {GuestModel} from '../../../guests/model'
import {FilterRegex} from '../../../../../../util/functions'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getChekings: (data: any) => void
  isCheckin: boolean
}

const ModalSearchHuesped: FC<Props> = ({show, setShow, getChekings, isCheckin}) => {
  const [, setHuespedList] = useState<Array<GuestModel>>([])
  const [loading, setLoading] = useState(false)
  const [, setIsFiltred] = useState(false)

  const searchHuespedSchema = Yup.object().shape({
    TipoDocumentoId: Yup.string().required('Tipo de documento es requerido'),
    NumeroDocumento: Yup.string().required('Número de documento es requerido'),
  })

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: {errors},
    watch,
  } = useForm<SearchHuespedModel>({
    resolver: yupResolver(searchHuespedSchema),
  })
  const tipoDocumento = watch('TipoDocumentoId')
  const numeroDocumento = watch('NumeroDocumento')

  const handleClose = () => {
    setShow(false)
  }
  let numeroDocumentoChangeTimeout: any

  const handleNumeroDocumentoChange = useCallback(
    (value: string) => {
      setValue('NumeroDocumento', value)
      clearTimeout(numeroDocumentoChangeTimeout)
      numeroDocumentoChangeTimeout = setTimeout(() => {
        if (value?.length > 0) {
          const input = document.querySelector('input[name="NumeroDocumento"]')
          if (input) {
            input.dispatchEvent(new KeyboardEvent('keydown', {key: 'Enter'}))
            input.addEventListener('keydown', handleEnterKey as EventListener)
          }
        }
      }, 2000)
    },
    [setValue],
  )

  const handleSubmitFake = async () => {
    setLoading(true)
    setIsFiltred(true)
    const {data: response} = await searchGuestService({
      NumeroDocumento: numeroDocumento,
      TipoDocumentoId: tipoDocumento,
    })
    setLoading(false)
    if (response.data.length === 0) {
      Swal.fire('Ups!', 'Parece que el huésped no tiene una reserva asignada!', 'warning')

      return
    }
    getChekings({UsuarioId: response.data[0].UsuarioId})
  }

  const handleEnterKey = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleSubmitFake()

      const input = document.querySelector('input[name="NumeroDocumento"]')
      if (input) {
        input.removeEventListener('keydown', handleEnterKey as EventListener)
      }
    }
  }

  useEffect(() => {
    handleNumeroDocumentoChange(numeroDocumento)
    const input = document.querySelector('input[name="NumeroDocumento"]')
    if (input) {
      input.addEventListener('keydown', handleEnterKey as EventListener)
    }
    return () => {
      if (input) {
        input.removeEventListener('keydown', handleEnterKey as EventListener)
      }
    }
  }, [numeroDocumento, handleNumeroDocumentoChange])

  useEffect(() => {
    setHuespedList([])
    setValue('NumeroDocumento', '')
  }, [])

  const onSubmit = async (data: SearchHuespedModel) => {
    setLoading(true)
    setIsFiltred(true)
    const {data: response} = await searchGuestService(data)
    setLoading(false)
    if (response.data.length === 0) {
      Swal.fire('Ups!', 'Parece que el huésped no tiene una reserva asignada!', 'warning')

      return
    }
    getChekings({UsuarioId: response.data[0].UsuarioId})
  }
  let typeName =
    watch('TipoDocumentoId') === '00' || watch('TipoDocumentoId') === '07'
      ? 'alphaNumeric'
      : 'numeric'
  console.log(typeName)
  let regex = FilterRegex(typeName)
  console.log(regex)
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: {onChange: (value: string) => void},
  ) => {
    let value = e.target.value
    console.log('valor', value)
    if (!regex.test(value)) {
      console.log('valida')
      return
    }
    value = value.toUpperCase()
    field.onChange(value)
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Buscar Huésped</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='row p-3 pb-5'>
              <div className='col-3 col-md-3'></div>
              <div className='col-6  col-md-6 '>
                <label className='required form-label'>Número de documento</label>
                <div className='input-group input-group-sm'>
                  <select
                    {...register('TipoDocumentoId')}
                    defaultValue={'01'}
                    className='form-select form-select-solid form-select-sm select2-hidden-accessible'
                  >
                    <option value='00'>FOTOCHECK</option>
                    <option value='01'>DNI</option>
                    <option value='04'>CE</option>
                    <option value='07'>PASAPORTE</option>
                  </select>
                  <Controller
                    control={control}
                    name='NumeroDocumento'
                    render={({field}) => (
                      <input
                        {...field}
                        {...register('NumeroDocumento')}
                        type='text'
                        className='form-control'
                        onChange={(e) => handleChange(e, field)}
                        autoFocus
                      />
                    )}
                  />
                </div>
                <p
                  style={{
                    marginBottom: '0',
                    fontSize: '10px',
                    fontWeight: '600',
                    color: 'red',
                    marginLeft: '5px',
                  }}
                >
                  {errors.NumeroDocumento?.message}
                </p>
              </div>
              <div className='col-3  col-md-3'></div>
            </div>
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button
                type='button'
                className='btn btn-primary'
                onClick={handleSubmit(onSubmit)}
                disabled={loading}
              >
                {!loading && 'Buscar'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Buscando...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalSearchHuesped}
